// src/components/Header.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoMonite from '../assets/logo_new_trans.png';
import { trackLangSwitch, trackNavClick } from '../analytics/events';

const normalizeLanguage = (lng) => {
  if (!lng) return 'fr';
  const mainLang = lng.split('-')[0].toLowerCase();
  switch (mainLang) {
    case 'en': return 'en';
    case 'he':
    case 'iw': return 'he';
    case 'fr':
    default: return 'fr';
  }
};

export default function Header() {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    const normalizedLang = normalizeLanguage(i18n.language);
    setCurrentLanguage(normalizedLang);
    if (normalizedLang !== i18n.language) {
      i18n.changeLanguage(normalizedLang);
    }
  }, [i18n.language, i18n]);

  useEffect(() => {
    if (i18n.isInitialized) {
      setCurrentLanguage(normalizeLanguage(i18n.language));
    }
  }, [i18n.isInitialized, i18n.language]);

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const closeMenu = () => setIsMenuOpen(false);

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    trackLangSwitch({ from: currentLanguage, to: newLang });
    setCurrentLanguage(newLang);
    i18n.changeLanguage(newLang);
  };

  const onNav = (target) => () => {
    trackNavClick({ target, location: 'header' });
    closeMenu();
  };

  return (
    <header className="App-header sticky">
      {isMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMenu}></div>
      )}
      <div className="header-content">
        <div className="logo-section">
          <Link to="/" onClick={onNav('home')}>
            <img src={logoMonite} alt="Logo Monite - Application chauffeur israélien et taxi Israel Friendly en France" className="monite-logo" width="50" height="50" />
            <div className="logo-text">
              <span className="logo-title">Monite</span>
              <span className="slogan">{t('common:slogan')}</span>
            </div>
          </Link>
        </div>
        <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Menu">
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        </button>
        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/#features" onClick={onNav('features')}>{t('common:features')}</Link>
          <Link to="/#about" onClick={onNav('about')}>{t('common:nav_about')}</Link>
          <Link to="/faq" onClick={onNav('faq')}>{t('common:nav_faq')}</Link>
          <Link to="/#contact" onClick={onNav('contact')}>{t('common:contact')}</Link>
          <Link to="/driver-showcase" onClick={onNav('driver_showcase')} className="driver-link">Espace Chauffeur</Link>
          <select className="lang-select" onChange={handleLanguageChange} value={currentLanguage}>
            <option value="fr">🇫🇷 FR</option>
            <option value="en">🇬🇧 EN</option>
            <option value="he">🇮🇱 HE</option>
          </select>
        </nav>
      </div>
    </header>
  );
}
